import styled, { keyframes } from 'styled-components';

const BgAnimation = keyframes`  
  0% {
  background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
}
`;

export const Container = styled.div`
  float: left;
  width: 100%;
  position: fixed;
  height: 100%;
  z-index: 4000;

  background: ${({ theme }) =>
    `linear-gradient(315deg ,${theme.colors.COLOR_1} 3%, ${theme.colors.COLOR_1} 38%, ${theme.colors.COLOR_1} 68%, ${theme.colors.COLOR_1} 98%)`};
  background-size: 400% 400%;
  background-attachment: fixed;

  animation-name: ${BgAnimation};
  animation-duration: 10s;
  animation-iteration-count: infinite;
  animation-direction: ease;
  padding: 2rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    background: ${({ theme }) => theme.colors.COLOR_1};
    background-size: 100% 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Ic = styled.div`
  margin-bottom: -4rem;
  margin-top: -6rem;
`;

export const Information = styled.div`
  width: 100%;
  max-width: 60rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 3rem 0 0 0;

  h1 {
    font-size: 2.2rem;
  }

  p {
    background: ${({ theme }) => theme.colors.TEXT1};
    font-size: 1.4rem;
    margin: 0.5rem 0 0 0;
  }

  @media (max-width: 1024px) {
    h1 {
      font-size: 1.4rem;
      text-align: center;
    }
    p {
      font-size: 1rem;
      text-align: center;
    }
  }
`;

export const Opts = styled.div`
  float: left;
  display: flex;
  flex-direction: row;
  margin: 2rem 0 0 0;

  @media (max-width: 1024px) {
    flex-direction: column;
    button {
      margin-top: 2rem;
    }
  }
`;

const WaveAnimation = keyframes`  
   2% {
        transform: translateX(1);
    }

    25% {
        transform: translateX(-25%);
    }

    50% {
        transform: translateX(-50%);
    }

    75% {
        transform: translateX(-25%);
    }

    100% {
        transform: translateX(1);
    }
`;

export const Waves = styled.div`
  .wave {
    background: ${({ theme }) => theme.colors.COLOR_1};
    border-radius: 1000% 1000% 0 0;
    position: fixed;
    width: 200%;
    height: 12em;
    animation: ${WaveAnimation} 10s -3s linear infinite;
    transform: translate3d(0, 0, 0);
    opacity: 0.8;
    bottom: 0;
    left: 0;
    z-index: -1;
  }

  .wave:nth-of-type(2) {
    bottom: -1.25em;
    animation: ${WaveAnimation} 18s linear reverse infinite;
    opacity: 0.8;
  }

  .wave:nth-of-type(3) {
    bottom: -2.5em;
    animation: ${WaveAnimation} 20s -1s reverse infinite;
    opacity: 0.9;
  }
`;
